import AcknowledgeCancellation from "../symbols/acknowledgeCancellation";

const initialState = {
  data: [],
  loading: false,
  error: false,
};

export default function AcknowledgeCancellationReducer(
  state = initialState,
  action: any
) {
  switch (action.type) {
    case AcknowledgeCancellation.ACKNOWLEDGE_CANCELLATION:
      return { ...state, loading: true, error: false };
    case AcknowledgeCancellation.ACKNOWLEDGE_CANCELLATION_SUCCESS:
      return {
        ...state,
        data: action.payload.Result,
        loading: false,
        error: false,
      };
    case AcknowledgeCancellation.ACKNOWLEDGE_CANCELLATION_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    case AcknowledgeCancellation.CLEAR_ACKNOWLEDGE_CANCELLATION:
      return {
        ...state,
        data: [],
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
